import PageTitle from "../../../Components/UI/PageTitle";
import AddOrEditLesson from "../../../Components/CoursesModuleComponents/AddOrEditLesson";
import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { getCourseName, getLessonDataToUpdate } from "../../../apis";
import Swal from "sweetalert2";
import Loader from "../../../Components/Loader";
import { getTotalMinutes } from "../../../_helper";

const EditLessonInCourse = () => {
  const { courseId, lessonId } = useParams();
  const [dataToUpdate, setDataToUpdate] = useState({});
  const [getDataLoading, setGetDataLoading] = useState(true);

  useEffect(() => {
    if (lessonId) {
      setGetDataLoading(true);
      getLessonDataToUpdate(courseId, lessonId)
        .then((response) => {
          setDataToUpdate(response.data.lesson);
        })
        .catch((error) => {
          console.error("Error fetching data to update:", error);
          Swal.fire("Error", "Failed to load social media data", "error");
        })
        .finally(() => {
          setGetDataLoading(false);
        });
    }

    return () => {
      setDataToUpdate([]); // Reset state when component unmounts
    };
  }, [courseId, lessonId]);

  const handleInitialValues = {
    lesson_name_english: dataToUpdate?.lesson_name_en,
    lesson_name_arabic: dataToUpdate?.lesson_name_ar,
    lesson_description_english: dataToUpdate?.lesson_description_en,
    lesson_description_arabic: dataToUpdate?.lesson_description_ar,
    lesson_type: dataToUpdate?.lesson_type,
    level: dataToUpdate?.level,
    is_active: dataToUpdate?.is_active,
    duration: getTotalMinutes(dataToUpdate?.duration),
    video_link: dataToUpdate?.link,
    confirm: false,
  };

  const [courseName, setCourseName] = useState("");
  useEffect(() => {
    getCourseName(courseId).then((response) => {
      setCourseName(response.data.name);
    });
  }, [courseId]);

  if (getDataLoading) return <Loader />;
  return (
    <>
      <PageTitle
        BreadcrumbItems={[
          { title: "Home", link: "/" },
          {
            title: "Courses Management",
            link: `/courses-management`,
          },
          { title: "Course Details", link: `/courses-management/${courseId}` },
          {
            title: "Lessons List",
            link: `/courses-management/${courseId}/lessons-in-course`,
          },
          { title: "Edit Lesson" },
        ]}
      />
      <h2 className="h4">
        Edit Lesson In{" "}
        <span className="tw-text-primary">{courseName || ""}</span> Course
      </h2>
      <AddOrEditLesson mode="edit" initialValues={handleInitialValues || {}} />
    </>
  );
};

export default EditLessonInCourse;
